(function () {
  const initSmileUI = () => {
    const smileContainer = document.querySelector('#smile-ui-container');
    const launcherContainer = document.querySelector('.smile-launcher-frame-container');
    const launcherFrame = document.querySelector('.smile-launcher-frame');

    if (!smileContainer || !launcherContainer || !launcherFrame) {
      const observer = new MutationObserver(() => {
        if (
          document.querySelector('#smile-ui-container') &&
          document.querySelector('.smile-launcher-frame-container') &&
          document.querySelector('.smile-launcher-frame')
        ) {
          observer.disconnect();
          initSmileUI();
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
      return;
    }

    // 设置 bottom 为 0
    launcherContainer.style.setProperty('bottom', '0', 'important');

    // 缓存状态
    let isMobile = window.innerWidth <= 768;

    // 设置 iframe 延迟加载
    if (!launcherFrame.src && launcherFrame.dataset.src) {
      const loadFrameSrc = () => { launcherFrame.src = launcherFrame.dataset.src; };
      if ('requestIdleCallback' in window) {
        requestIdleCallback(loadFrameSrc, { timeout: 2000 });
      } else {
        setTimeout(loadFrameSrc, 100);
      }
    }

    // 更新显示状态的函数
    const updateVisibility = () => {
      if (isMobile) {
        smileContainer.classList.toggle('visible', launcherContainer.classList.contains('smile-launcher-open'));
      }
    };

    // 初始化显示状态
    updateVisibility();

    // 使用节流的 resize 监听
    let resizeTimeout;
    window.addEventListener('resize', () => {
      if (!resizeTimeout) {
        resizeTimeout = setTimeout(() => {
          const newIsMobile = window.innerWidth <= 768;
          if (newIsMobile !== isMobile) {
            isMobile = newIsMobile;
            updateVisibility();
          }
          resizeTimeout = null;
        }, 200);
      }
    });

    // 监听状态变化
    const observer = new MutationObserver(updateVisibility);
    observer.observe(launcherContainer, {
      attributes: true,
      attributeFilter: ['class'],
    });
  };

  // 确保 DOM 加载完成后再初始化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSmileUI);
  } else {
    initSmileUI();
  }
})();